import { useCallback } from "react";

import { useCustomSuspenseQuery } from "@/hooks/use-graphql-client";

import { RoomStock_StockManagement_Query } from "./query";

type Props = {
	hotelID: string;
	startDt: string;
	endDt: string;
};

/**
 * 年月に紐づく部屋在庫を取得する
 * @returns
 */
export const useFetchRoomStock = ({ hotelID, startDt, endDt }: Props) => {
	// 部屋在庫取得ロジック
	const { data, refetch } = useCustomSuspenseQuery(RoomStock_StockManagement_Query, {
		variables: { hotelID, startDt, endDt },
	});

	const onFetchRoomStock = useCallback(
		async ({ input: { startDt, endDt } }: { input: { startDt: string; endDt: string } }) => {
			return await refetch({ hotelID, startDt, endDt });
		},
		[hotelID, refetch],
	);

	return {
		data,
		onFetchRoomStock,
	};
};
